import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Table, Params } from 'nallian-table-builder-ui';
import apiRoutes from '../../../../app/api/routes';
import { ACTIONS, COMMUNITY_DETAIL_TABS } from '../../../communities/constants';
import PopupAndCopy from '../../../app/components/PopupAndCopy';
import { INFINITE_SCROLL } from '../../constants';

const AppCommunities = () => {
  const { t } = useTranslation();
  const { id: appId } = useParams();

  if (!appId) {
    return null;
  }

  return (
    <Table
      resource={`appCommunities_${appId}`}
      url={apiRoutes.appCommunities(appId)}
      noResultsMessage={t('noCommunitiesFound')}
      infiniteScroll={INFINITE_SCROLL}
      pageSize={50}
      filtered
      sorted
      resizable
    >
      <Params.String
        name="name"
        filterName="communityName"
        sortName="communityName"
        width="9rem"
        minWidth="9rem"
        link={`/communities/${ACTIONS.EDIT}/:id/${COMMUNITY_DETAIL_TABS.DETAILS}`}
        grow
      />
      <Params.String
        name="tag"
        filterName="communityTag"
        sortName="communityTag"
        width="9rem"
        minWidth="9rem"
        grow
      />
      <Params.Custom
        content={PopupAndCopy}
        name="id"
        width="16rem"
        minWidth="16rem"
        grow
        noFilter
        noSort
      />
      <Params.Custom
        content={PopupAndCopy}
        name="tenantId"
        width="16rem"
        minWidth="16rem"
        grow
        noFilter
        noSort
      />
    </Table>
  );
};

export default AppCommunities;
